import axios from "axios";


const contextOptions = {
  part: ['parts-configuration', 'update', 'update2', 'popup', 'Popup2'],
  profile: Array.from({ length: 3 }).map((_, i) => ({ label: `Profile Action ${i}`, icon: i < 4 ? 'icon-windows' : '' })),
  part_image: ['image1', 'image2'],
  notifications: Array.from({ length: 4 }).map((_, i) => ({ label: `Notifications Action ${i}`, icon: 'icon-windows' })),
}


export const getContextMenuOptions = (body) => {
  let mockOptions = contextOptions[body.type ?? 'default'];
 return Promise.resolve({data: {responseCode: 200, load: mockOptions}});
  // return axios.post(`http://localhost:3000/get-context-menu-options`, body, {hideLoader: true});
}

export function attachContextmenuInfo({event, type, data, highlightstyle, options}) {
  event.contextMenuInfo = event.contextMenuInfo ?? { type, data, highlightstyle, options, target: event.currentTarget}
  
}